import React, { useEffect, useState } from 'react'
import { getDateCombination, isImageValidPng } from '../../../commonClass/CommonValidation';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Lightbox from 'yet-another-react-lightbox';
import ReactSwitch from 'react-switch';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';

const NewPitchingSection = ({ travelCategoryId, useredit, useradd }) => {
    const dispatch = useDispatch();

    const getFolderName = (id) => {
        switch (id) {
            case 1: return 'Flights';
            case 2: return 'Holidays';
            case 5: return 'Hotels';
            default: return '';
        }
    }

    const folderName = getFolderName(travelCategoryId);
    const [formValue, setFormValue] = useState({
        PitchingSectionId: 0,
        TravelCategoryId: travelCategoryId,
        IsActive: false,
        UserId: 0,
        ImageList: []
    })
    const [imageList, setImageList] = useState([]);
    const [formError, setFormError] = useState(null);

    const [onPhotoHover, setOnPhotoHover] = useState(-1);
    const [isOpen, setIsOpen] = useState(false);
    const [indexs, setIndexs] = useState(1);
    const [src, setSrc] = useState([]);
    const [modalShow, setModalShow] = useState(false);

    //#region Call GET API Function
    const getpitchingbytravelcategoryid = async () => {
        const pitchingbytravelcategoryid = await getAllData(`/master/v1/getpitchingbytravelcategoryid?travelCategoryId=${travelCategoryId}`)
        if (pitchingbytravelcategoryid?.status) {
            setImageList(pitchingbytravelcategoryid?.data ? pitchingbytravelcategoryid?.data : []);
            setFormValue({
                ...formValue,
                IsActive: pitchingbytravelcategoryid?.data?.[0]?.IsActive
            });
        }
    }
    //#endregion

    //#region Check Token and Call GET API Function in useEffect with travelCategoryId
    useEffect(() => {
        async function fetchData() {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                getpitchingbytravelcategoryid();
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                dispatch(loaderActions.end());
            }
        }

        if (travelCategoryId) {
            fetchData();
        }
    }, [travelCategoryId])
    //#endregion

    const handleUploadDoc = (e) => {
        setFormError(null);
        const files = Array?.from(e?.target?.files || []);
        let newFileType = files?.filter((file) => isImageValidPng(file?.name))
        let newFileSize = newFileType?.filter((file) => ((file?.size / 1024) / 1024) < 5)
        let error = {}
        if (files?.length !== newFileType?.length) {
            error.imageUpload = 'Only PNG file type is accepted.';
            setFormError(error);
            e.target.value = null
        }
        else if (files?.length !== newFileSize?.length) {
            error.imageUpload = 'Cannot upload file that exceeds 5 MB.';
            setFormError(error);
            e.target.value = null
        }
        const tempImageList = newFileSize?.slice(0, imageList ? 5 - imageList?.length : 5)?.reduce((acc, file, index) => {
            const filename = getDateCombination(file?.name);
            acc.push({
                PitchingSectionId: 0,
                TravelCategoryId: 0,
                ImageName: filename,
                ImagePath: `CMS/Merchandising/${folderName}/Pitching/${filename}`,
                Path: `CMS/Merchandising/${folderName}/Pitching/`,
                File: file,
                needToUpload: true,
                uploaded: false,
                isDelete: false
            });

            return acc;
        }, []);
        setImageList((prev) => [...prev, ...tempImageList]);
    }

    const handleDeleteFile = (mediaId, indexId) => {
        setFormError(null);
        if (mediaId === 0) {
            setImageList((prev) => prev.filter((item, index) => index !== indexId));
        }
        else {
            setImageList(imageList?.map((obj) => {
                if (obj.PitchingSectionId === mediaId) {
                    obj.isDelete = true;
                }
                return obj;
            }));
        }
    }

    const deleteImages = async () => {
        await Promise.all(
            imageList?.filter((item) => item?.isDelete)?.map(async (ele) => {
                if (ele?.isDelete) {
                    try {
                        await ImageDelete(ele?.ImagePath);
                    } catch (error) {
                        console.error(`Error Upload Image: ${error}`)
                        dispatch(loaderActions.end())
                    }
                }
                return ele;
            })
        )
    }

    const validateData = () => {
        let status = true;
        let error = {}
        if (imageList?.filter((item) => !item?.isDelete)?.length <= 0) {
            error.imageUpload = 'Input is mandatory.';
            status = false;
        }
        setFormError(error);
        return status;
    }

    const onSubmitPitching = async () => {
        if (formError === null && validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                let newImageList = imageList?.filter((obj) => obj?.needToUpload)
                formValue.ImageList = imageList?.filter((item) => !item?.isDelete)
                formValue.UserId = user?.userMasterID
                const insertorupdatepitchingsection = await postUsersData('/master/v1/insertorupdatepitchingsection', formValue);

                if (insertorupdatepitchingsection.status) {
                    await Promise.all(
                        newImageList?.map(async (ele) => {
                            if (ele?.needToUpload) {
                                try {
                                    let uploaded = await ImageUpload(ele?.Path, ele?.ImageName, ele?.File);
                                    if (imageList?.filter((item) => item?.isDelete)?.length > 0) {
                                        await deleteImages();
                                    }
                                    ele.uploaded = uploaded
                                } catch (error) {
                                    console.error(`Error Upload Image: ${error}`)
                                    dispatch(loaderActions.end())
                                }
                            }
                            return ele;
                        })
                    )
                    getpitchingbytravelcategoryid();
                    dispatch({ type: 'ALERTING', message: insertorupdatepitchingsection.message });
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertorupdatepitchingsection.message })
                    dispatch(loaderActions.end());
                    return;
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }

    }

    const clearData = () => {
        setFormError(null);
        setImageList([]);
        setFormValue({
            ...formValue,
            PitchingSectionId: 0,
            ImageList: [],
        });
        document.getElementById('imageUpload').value = '';
    }

    const handleViewImage = (index, path) => {
        setFormError(null)
        setSrc((current) => [...current, { ...src, src: path }])
        setIsOpen(true);
        setIndexs(index)
    }

    const handleisActive = (e) => {
        if (!formValue?.IsActive) {
            setFormError(null);
            setFormValue({
                ...formValue,
                IsActive: !formValue?.IsActive
            });
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormError(null);
            setFormValue({
                ...formValue,
                IsActive: !formValue?.IsActive
            });
        }
        setModalShow(false);
    }

    return (
        <div className='px-md-4 px-2 py-4'>
            <div className="container-fluid heading_color">
                <h4>Pitching</h4>
                <form action="">
                    <div className="row">
                        <div className='col-md-6 col-12'>
                            <div className="row">
                                <div className="col-lg-4 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                    <label htmlFor="imageUpload" className="col-form-label required">Pitching Banner</label>
                                </div>
                                <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                    <div className="input-group">
                                        <input type="file"
                                            multiple
                                            className="form-control btn_add"
                                            id="imageUpload"
                                            name='imageUpload'
                                            accept='.png'
                                            disabled={!useredit && !useradd}
                                            onChange={(e) => handleUploadDoc(e)}
                                        />
                                        <label className="input-group-text" htmlFor="imageUpload">Browse</label>
                                    </div>
                                    {formError?.imageUpload && <p className="text-start text-danger mb-0"> {formError?.imageUpload} </p>}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 col-12'>
                            <div className='row align-items-center'>
                                <div class="col-lg-4 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                    <label for="inputPassword6" class="col-form-label">Active/Inactive</label>
                                </div>

                                <div class="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                    <div class="input-group">
                                        <ReactSwitch
                                            id='active'
                                            onChange={handleisActive}
                                            checked={formValue?.IsActive}
                                            className="react-switch"
                                            disabled={!useredit && !useradd}
                                        />
                                    </div>
                                </div>
                                <ConfirmationModal
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    noconfirm={() => handleConfirmation(false)}
                                    yesconfirm={() => handleConfirmation(true)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row row-cols-xl-3 row-cols-lg-3 row-cols-sm-2 row-cols-1 g-2 my-3 my-sm-3">
                        {
                            imageList?.filter((item) => !item?.isDelete)?.map((img, index) => {
                                return (
                                    <div className={`col position-relative`} key={index}
                                        onMouseEnter={() => setOnPhotoHover(index)}
                                        onMouseLeave={() => setOnPhotoHover(-1)}
                                    >
                                        <img
                                            src={
                                                img?.needToUpload ?
                                                    URL.createObjectURL(img?.File) :
                                                    `${CommonFileURLWithFolder}${img?.ImagePath}`
                                            }
                                            key={index}
                                            className={`home_banner_img`}
                                            alt={img?.ImageName}
                                            loading='lazy'
                                        />
                                        {
                                            (!(!useredit && !useradd) && onPhotoHover === index) && (
                                                <>
                                                    <div key={index} className="pitching_image_hover position-absolute text-center align-content-center">
                                                        <div className='option_icon rounded-pill py-3' >
                                                            <button type="button" className="mx-2 btn p-0" onClick={() => handleDeleteFile(img?.PitchingSectionId, index)}>
                                                                <i className="fa-solid fa-trash-can"></i>
                                                            </button>
                                                            <button type="button" className="mx-2 btn p-0"
                                                                onClick={() =>
                                                                    handleViewImage(index,
                                                                        img?.needToUpload ? URL.createObjectURL(img?.File) : `${CommonFileURLWithFolder}${img?.ImagePath}`
                                                                    )}
                                                            >
                                                                <i className="fa-solid fa-eye"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {isOpen && (
                                                        <Lightbox
                                                            slides={src}
                                                            open={indexs >= 0}
                                                            index={indexs}
                                                            close={() => { setIndexs(-1); setSrc([]); }}
                                                            plugins={[Zoom]}
                                                            render={{
                                                                buttonPrev: src.length <= 1 ? () => null : undefined,
                                                                buttonNext: src.length <= 1 ? () => null : undefined,
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )
                                        }

                                    </div>
                                )
                            })
                        }
                    </div>

                    <div class="d-flex justify-content-center mt-5">
                        <button class="btn btn-primary mx-1" id="btnAdd" type='button'
                            onClick={() => onSubmitPitching()}
                            disabled={!useredit && !useradd}
                        >Add</button>
                        <button type="button" class="btn btn-primary mx-1" id="btnClear"
                            disabled={!useredit && !useradd}
                            onClick={() => clearData()}
                        >Clear</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default NewPitchingSection
